import PropTypes from 'prop-types';
import { createContext, useContext } from 'react';
const PermissionsContext = createContext(null);

const withPermissions = (permissions) => (WrappedComponent) => {
    const WithPermissions = (props) => {
        const context = useContext(PermissionsContext);

        const hasPermissions = permissions.some(
            (p) => Object.prototype.hasOwnProperty.call(context?.permissions || {}, p) && context.permissions[p],
        );

        if (!hasPermissions) {
            return null;
        }

        return <WrappedComponent {...props}>{props.children}</WrappedComponent>;
    };

    WithPermissions.displayName = `withPermissions(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

    WithPermissions.propTypes = {
        children: PropTypes.node,
    };

    return WithPermissions;
};

const withSettings = (WrappedComponent) => {
    const WithSettings = (props) => {
        const context = useContext(PermissionsContext);
        const settings = context?.settings || {};

        return <WrappedComponent {...props} settings={settings} />;
    };

    WithSettings.displayName = `withSettings(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return WithSettings;
};

const HasPermissions = ({ value, children }) => {
    const { permissions } = useContext(PermissionsContext);

    let hasPermissions = value.some((p) => Object.prototype.hasOwnProperty.call(permissions, p) && permissions[p]);
    return hasPermissions ? children : null;
};

const LimitPermissions = ({ value, children }) => {
    const { permissions } = useContext(PermissionsContext);

    let hasPermissions = value.some((p) => Object.prototype.hasOwnProperty.call(permissions, p) && permissions[p]);
    return hasPermissions ? null : children;
};

HasPermissions.propTypes = {
    value: PropTypes.any,
    children: PropTypes.any,
};

LimitPermissions.propTypes = {
    value: PropTypes.any,
    children: PropTypes.any,
};

export { PermissionsContext, withPermissions, HasPermissions, LimitPermissions, withSettings };
